/**
 * The album that a media item belongs to
 */
export enum MediaAlbum {
  /**
   * Private
   */
  Private = 'private',

  /**
   * Shared
   */
  Shared = 'shared',
}
